import { render } from "./CheckButton.vue?vue&type=template&id=080fecd3&scoped=true"
import script from "./CheckButton.vue?vue&type=script&lang=js"
export * from "./CheckButton.vue?vue&type=script&lang=js"

import "./CheckButton.vue?vue&type=style&index=0&id=080fecd3&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-080fecd3"

export default script